export default class ClubFeeCategory {
    static fromData(data) {
        if (!data) {
            return;
        }

        let clubFeeCategory = new ClubFeeCategory();
        clubFeeCategory.id = data.id;
        clubFeeCategory.name = data.name;
        clubFeeCategory.paymentApproach = data.paymentApproach;

        Object.seal(clubFeeCategory);
        return clubFeeCategory;
    }
}
